const BASE_URL_SERVER = `${process.env.VUE_APP_SERVER_URL}`;

import axios from "axios";

const API_ENDPOINT = {
    LOGIN_GOOGLE_API: '/api/auth/google',
    INFO_API: '/api/player/info',
}

class UserService {
    loginGoogle = () => {
        return axios.get(BASE_URL_SERVER + API_ENDPOINT.LOGIN_GOOGLE_API);
    };

    getInfo = (token) => {
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            }
        };
        return axios.get(BASE_URL_SERVER + API_ENDPOINT.INFO_API, config);
    };
}

const userService = new UserService();
export default userService;